module.exports = __webpack_public_path__ + "static/img/neatorama.com.97643ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/thumbs/neatorama.com.jpg
// module id = 37
// module chunks = 1